export default "__VITE_ASSET__ccc9f865__"